module.exports = __webpack_public_path__ + "static/media/img168.9bbcc771.jpg";